module.exports = __webpack_public_path__ + "static/media/intro_icon_4.6b31faf2.svg";